import { cancelOtherReason } from "../../../../../../../v3/pages/CancelAppointment/routes/default/CancelAppointmentReasons.js";
const getCancellationReasonValue = ({
  formState
}) => {
  const cancellationReason = formState.cancellationReason?.value;
  const otherCancellationReason = formState.otherCancellationReason?.value;
  if (cancellationReason === cancelOtherReason) {
    return otherCancellationReason || cancellationReason;
  }
  return cancellationReason || otherCancellationReason;
};
export {
  getCancellationReasonValue
};
//# sourceMappingURL=get-cancellation-reason-value.js.map
